<template>
	<div>
		<div class="alarm-type-container">
			<div id="left-arrow" class="before-renderer">
				<div class="arrow-button">
					<div style="width: 32px; height: 32px; margin: 0 12px; cursor: pointer" v-on:click="scroll(-300)">
						<svg viewBox="0 0 16 16" preserveAspectRatio="xMidYMid meet" focusable="false" class="style-scope yt-icon" style="pointer-events: none; display: block; width: 100%; height: 100%;"><g mirror-in-rtl="" class="style-scope yt-icon"><path d="M10.15,13.35L4.79,8l5.35-5.35l0.71,0.71L6.21,8l4.65,4.65L10.15,13.35z" class="style-scope yt-icon"></path></g></svg>
					</div>
				</div>
			</div>
			<div ref="container" id="container" class="horizontal alarm-type-buttons-container">
				<div v-for="aT in alarmTypes" :key="aT.id">
					<div :class="['alarm-type-card', { 'selected-alarm-type' : aT.id == computedId}]" v-on:click="changeSelection(aT)">
						<div class="noselect" style="font-weight: bolder; font-size: 12px; word-break: break-word;" >{{$t(aT.description)}} <span style="font-size: 12px;">({{aT.numberOfAlarms}})</span></div>
					</div>
				</div>
			</div>
			<div id="right-arrow" class="before-renderer">
				<div class="arrow-button">
					<div style="width: 32px; height: 32px; margin: 0 12px; cursor: pointer" v-on:click="scroll(300)">
						<svg viewBox="0 0 16 16" preserveAspectRatio="xMidYMid meet" focusable="false" class="style-scope yt-icon" style="pointer-events: none; display: block; width: 100%; height: 100%;"><g mirror-in-rtl="" class="style-scope yt-icon"><path d="M4.97,12.65L9.62,8L4.97,3.35l0.71-0.71L11.03,8l-5.35,5.35L4.97,12.65z" class="style-scope yt-icon"></path></g></svg>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { getAllAlarmTypesForSystem } from "../../api/api";

var context = null;

export default {
	name: "AlarmTypesSelect",
	props: {
		priority: {
			type: Number,
			required: true
		},
		preSelectedAlarm: {
			required: false,
			default: null
		},
		systemId: {
			type: String,
			required: true
		},
		dateFrom: {
			type: Date,
			required: true,
		},
		dateTo: {
			type: Date,
			required: true
		},
		allTypes: {
			type: Boolean,
			required: true
		}
	},
	computed: {
		computedId() {
			return this.selectedAlarm !== undefined ? this.selectedAlarm.id : '-1'
		}
	},
	watch: {
		priority(newVal, oldVal){
			this.getData()
		},
		allTypes() {
			this.getData()
		},
		dateFrom(newVal, oldVal) {
			this.getData()
		},
		dateTo(newVal, oldVal){
			this.getData()
		},
		preSelectedAlarm(newVal, oldVal) {
			this.getData()
		}
	},
	data() {
		return {
			selectedAlarm: null,
			alarmTypes: [],
			allAlarmTypes: [],
			selectedAlarmIndex: 0
		}
	},
	methods: {
		scroll(value){
			let scrollAmount = 0;
			let slideTimer = setInterval(function(){
				context.$refs.container.scrollLeft += value / 20;
				scrollAmount += 20;
				if(scrollAmount >= Math.abs(value)){
					window.clearInterval(slideTimer);
				}

				if(context.$refs.container.scrollLeft === 0){
					document.getElementById("left-arrow").style.display = 'none'
				} else {
					document.getElementById("left-arrow").style.display = 'flex'
				}

				if((context.$refs.container.scrollWidth > context.$refs.container.offsetWidth + context.$refs.container.scrollLeft)) {
					document.getElementById("right-arrow").style.display = 'flex'
				} else {
					document.getElementById("right-arrow").style.display = 'none'
				}

			}, 10);

			if(this.$refs.container.scrollLeft < 100){
				document.getElementById("left-arrow").style.display = 'none'
			} else {
				document.getElementById("left-arrow").style.display = 'flex'
			}

			if((this.$refs.container.scrollWidth > this.$refs.container.offsetWidth + this.$refs.container.scrollLeft) || value == 0) {
				document.getElementById("right-arrow").style.display = 'flex'
			} else {
				document.getElementById("right-arrow").style.display = 'none'
			}
		},
		async getData(){
			let data = await getAllAlarmTypesForSystem(this.systemId, this.dateFrom.toISOString(), this.dateTo.toISOString());
			this.allAlarmTypes = data
			let allAlarms = [...this.allAlarmTypes.filter(x => x.priority == this.priority)]
			if(!this.allTypes){
				allAlarms = allAlarms.filter(x => x.numberOfAlarms > 0)
			}
			this.alarmTypes = [...allAlarms.sort((a,b) => b.numberOfAlarms - a.numberOfAlarms)]
			this.selectedAlarm = this.preSelectedAlarm == null || this.preSelectedAlarm == '' ? allAlarms[0] : allAlarms[allAlarms.findIndex(x => x.description === this.preSelectedAlarm)]

			this.scroll(0)
		},
		changeSelection(selection) {
			this.selectedAlarm = selection
			if(this.selectedAlarm != undefined) {
				this.selectedAlarmIndex = this.alarmTypes.findIndex(x => x.id == this.selectedAlarm.id)
			}
			this.$emit('alarmTypeChanged', selection)
		}
	},
	mounted: async function() {
		this.getData();
		this.scroll(0)
		context = this;
	}
}
</script>

<style>
.tippy-popper[x-placement^=bottom] .tippy-tooltip.customTheme-theme .tippy-arrow {
	border-bottom: 8px solid #346F8B;
}
</style>

<style scoped>
::-webkit-scrollbar {
	display: none;
}

.alarm-type-container {
	max-width: 90vw;
	white-space: nowrap;
	display: flex;
	flex: none;
}

.alarm-type-buttons-container {
	width: 90vw;
	max-width: 90vw;
	overflow-x: scroll;
	position: relative;
  scrollbar-width: none;
}

.alarm-type-card {
	display: flex;
	align-items: center;
	background-color: rgba(243, 243, 243, 1);
	cursor: pointer;
	padding: 0 12px;
	border: 1px solid rgba(224, 224, 224, 1);
	border-radius: 5px;
	height: 30px;
	margin: 5px 5px;
	box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.1);
	-ms-flex-item-align: center;
	text-align: left;
	background-color: white;
}

.alarm-type-card:hover {
	background-color: rgba(0, 125, 149, 0.1);
	color: black;
}

.selected-alarm-type {
	background-color: rgba(0, 125, 149, 1);
	color: white;
}

.arrow-button {
	z-index: 2000;
	width: 56px;
	height: 40px;
	background-color: rgba(249, 249, 249, 0.98);
	display: flex;
	flex-direction: column;
	justify-content: center;
}

.before-renderer {
	position: absolute;
	height: 40px;
	z-index: 2000;
	display: flex;
	flex-direction: row;
	justify-content: center;
}

#left-arrow.before-renderer:after {
	background: linear-gradient(to right, rgba(249, 249, 249, 0.98) 20%, rgba(249, 249, 249, 0) 80%);
}

#right-arrow.before-renderer:before {
	background: linear-gradient(to left, rgba(249, 249, 249, 0.98) 20%, rgba(249, 249, 249, 0) 80%);
}

#left-arrow.before-renderer:after, #right-arrow.before-renderer:before {
	height: 40px;
	width: 50px;
	content: "";
	pointer-events: none;
}

#left-arrow {
	left: 0;
	height: 40px;
	display: flex;
	flex-direction: row;
	justify-content: center;
}

#right-arrow  {
	right: 0;
	height: 40px;
	display: flex;
	flex-direction: row;
	justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Filters/AlarmTypesSelect.vue